export default __webpack_public_path__ + "static/want-to-work-a848915459d25111c7ea89d694e83d01.svg";